import { Navigate, useNavigate } from "react-router-dom";
import { Button, Box } from "@mui/material";
import { useAuth } from "../../app/providers/AuthProvider";
import TwoFactorAuth from "../../shared/components/common/ui/TwoFactorAuth/TwoFactorAuth";
import { useConfirmEmail } from "./hooks/useConfirmEmail";

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, logout, refreshUser } = useAuth();

  const email = user?.email ?? "";

  const {
    code,
    setCode,
    loading,
    error,
    timeLeft,
    verifyCode,
    resendCode,
  } = useConfirmEmail(email, async () => {
    await refreshUser(true);
    navigate("/painel", { replace: true });
  });

  const resendLabel =
    timeLeft > 0
      ? `Reenviar código (${timeLeft}s)`
      : "Reenviar código";

  if (!isAuthenticated) return null; // fallback de segurança
  if (String(user?.emailVerified).toLowerCase() === "true") {
    return <Navigate to="/painel" replace />;
  }

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Erro ao sair na tela de confirmação de e-mail:", err);
    }
  };

  return (
    <Box>
      <Button
        variant="text"
        size="small"
        onClick={handleLogout}
        sx={{
          position: "fixed",
          top: 12,
          right: 12,
          textTransform: "none",
          color: "text.secondary",
          minWidth: "auto",
          px: 1,
          py: 0.5,
          opacity: 0.8,
          zIndex: 10,
        }}
      >
        Sair
      </Button>

      <TwoFactorAuth
        headerProps={{
          providerName: "123zap",
          title: "Confirme seu e-mail",
          description:
            "Enviamos um código de 6 dígitos para o seu e-mail.",
          email,
        }}
        code={code}
        onCodeChange={setCode}
        codeLength={6}
        onSubmit={verifyCode}
        submitLabel="Finalizar cadastro"
        secondaryLabel={resendLabel}
        onSecondaryAction={resendCode}
        loading={loading}
        error={error}
        disableSecondary={timeLeft > 0}
        allowOnlyNumbers
      />
    </Box>
  );
};

export default VerifyEmailPage;
